import script from "./SystemUpdateBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./SystemUpdateBanner.vue?vue&type=script&setup=true&lang=ts"

import "./SystemUpdateBanner.vue?vue&type=style&index=0&id=f62a02e2&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f62a02e2"]])

export default __exports__